import { Injectable } from '@angular/core';

import { Observable, from as observableFrom } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

import { AcquisitionContextServiceBase } from '../../baseBtl/context/child/acquisition-context.service';
import { ContextInterface } from '../context.interface';
import { ContextService } from '../context.service';

@Injectable({
    providedIn: 'root',
})
export class AcquisitionContextService extends AcquisitionContextServiceBase /* implements ContextInterface*/ {
    public keySerialize: string = 'AcquisitionContextService';
    public contractId: string;
    public edp: boolean = false;

    public create(): Observable<ContextInterface> {
        const instance: AcquisitionContextService = new AcquisitionContextService(
            this.oauth2Ressource,
            this.promoContextService,
        );
        return instance.config();
    }

    public updateContext(contextService: ContextService): Observable<ContextService> {
        return this.promoContextService.create().pipe(
            mergeMap((res) => contextService.setContext(res)),
            map(() => contextService),
        );
    }

    public serialize(): { [index: string]: any } {
        return {
            contractId: this.contractId,
        };
    }

    public config(): Observable<ContextInterface> {
        return observableFrom([this]);
    }

    public get getPromoContextService() {
        return this.promoContextService;
    }
}
